import React from "react";
import { NewTab, PageHeader, PageTab } from "../../../../../components";
import ConsultantDetails from "./PermanentPlacement/ConsultantDetails";
import JobDetails from "./PermanentPlacement/JobDetails";
import Payments from "./PermanentPlacement/Payments";
import Invoices from "./PermanentPlacement/Invoices";
import Documents from "./PermanentPlacement/Documents";
import { useLocation } from "react-router-dom";

const AddPermanentPlacement = ({ onCancel, currentPlacement, editData }) => {
  const location = useLocation();
  const incomingData = location?.state?.incomingData || null;
  const handleBack = () => {
    if (onCancel) {
      onCancel();
    }
  };
  console.log("editData", editData);
  const PlacementMenus = [
    {
      title: "Job Details",
      page: (
        <JobDetails currentPlacement={currentPlacement} editData={editData} incomingData={incomingData} />
      ),
      type: "main",
    },
    // {
    //   title: "Consultant Details",
    //   page: <ConsultantDetails currentPlacement={currentPlacement}/>,
    //   type: "main",
    // },
    // {
    //   title: "Job Details",
    //   page: <JobDetails currentPlacement={currentPlacement}/>,
    //   type: "main",
    // },
    {
      title: "Payments",
      page: (
        <Payments currentPlacement={currentPlacement} editData={editData} incomingData={incomingData} />
      ),
      type: "main",
    },
    {
      title: "Invoices",
      page: (
        <Invoices currentPlacement={currentPlacement} editData={editData} />
      ),
      type: "main",
    },
    {
      title: "Documents",
      page: (
        <Documents
          currentPlacement={currentPlacement}
          handleBack={handleBack}
          editData={editData}
        />
      ),
      type: "main",
    },
  ];
  return (
    <>
      <div className="my-3">
        <PageHeader
          Section={
            <div>
              <h6>Permanent Placement</h6>
            </div>
          }
        />
      </div>
      <NewTab
        tabs={PlacementMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="permanent-placement"
      />
    </>
  );
};

export default AddPermanentPlacement;
